/**
 * Testimonials Slider — Dawn Theme
 * File: assets/section-testimonials.js
 */

(function () {
  'use strict';

  class TestimonialSlider {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.tst-slide'));
      this.dots   = Array.from(container.querySelectorAll('.tst-dot'));
      this.prevBtn = container.querySelector('[data-prev]');
      this.nextBtn = container.querySelector('[data-next]');

      this.total = this.slides.length;

      if (this.total <= 1) {
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        return;
      }

      this.current = 0;
      this._touchStartX = 0;
      this._touchStartY = 0;
      this._isAnimating = false;

      // Set explicit heights on track so inactive slides are invisible
      // but the track keeps the height of the active slide
      this._fixTrackHeight();
      this._bindEvents();
    }

    /* Force track to size itself to only the active slide */
    _fixTrackHeight() {
      // All inactive slides: remove from flow via position absolute inside the grid cell
      this.slides.forEach((slide, i) => {
        if (i !== 0) {
          slide.style.visibility = 'hidden';
          slide.style.position = 'absolute';
          slide.style.inset = '0';
          slide.style.maxHeight = '';
        }
      });
    }

    goTo(index) {
      if (this._isAnimating || index === this.current) return;
      this._isAnimating = true;

      const prev = this.current;
      const next = ((index % this.total) + this.total) % this.total;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Exit prev
      this.slides[prev].classList.remove('tst-slide--active');
      this.slides[prev].classList.add('tst-slide--exit');
      this.slides[prev].setAttribute('aria-hidden', 'true');
      this.slides[prev].style.visibility = '';

      // Enter next
      this.slides[next].style.visibility = '';
      this.slides[next].style.position = '';
      this.slides[next].style.inset = '';
      this.slides[next].classList.add('tst-slide--active');
      this.slides[next].setAttribute('aria-hidden', 'false');

      const duration = reduced ? 0 : 460;
      setTimeout(() => {
        this.slides[prev].classList.remove('tst-slide--exit');
        this.slides[prev].style.visibility = 'hidden';
        this.slides[prev].style.position = 'absolute';
        this.slides[prev].style.inset = '0';
        this._isAnimating = false;
      }, duration);

      // Dots
      if (this.dots[prev]) {
        this.dots[prev].classList.remove('tst-dot--active');
        this.dots[prev].setAttribute('aria-selected', 'false');
      }
      if (this.dots[next]) {
        this.dots[next].classList.add('tst-dot--active');
        this.dots[next].setAttribute('aria-selected', 'true');
      }

      this.current = next;
    }

    prev() { this.goTo(this.current - 1); }
    next() { this.goTo(this.current + 1); }

    _bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
      });

      this.container.addEventListener('touchstart', (e) => {
        this._touchStartX = e.touches[0].clientX;
        this._touchStartY = e.touches[0].clientY;
      }, { passive: true });

      this.container.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - this._touchStartX;
        const dy = e.changedTouches[0].clientY - this._touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          dx < 0 ? this.next() : this.prev();
        }
      }, { passive: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-testimonial-slider]').forEach((el) => {
      new TestimonialSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-testimonial-slider]');
    if (el) new TestimonialSlider(el);
  });
})();